type PropTypes = {
  className?: string
}

const CollapseIcon = ({ className }: PropTypes) => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_3143_14153)">
        <rect
          width="14"
          height="14"
          fill="white"
          fillOpacity="0.01"
          style={{ mixBlendMode: 'multiply' }}
        />
        <path d="M1.75 7.875V8.75H4.63138L0.875 12.5046L1.49363 13.125L5.25 9.36862V12.25H6.125V7.875H1.75Z" fill="#585962" />
        <path d="M13.125 1.4945L12.509 0.875L8.75 4.63138V1.75H7.875V6.125H12.25V5.25H9.36862L13.125 1.4945Z" fill="#585962" />
      </g>
      <defs>
        <clipPath id="clip0_3143_14153">
          <rect
            width="14"
            height="14"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export default CollapseIcon
